/*
 This file is a modified version of the original file from the BotFramework-WebChat repository.
 https://github.com/microsoft/BotFramework-WebChat/blob/main/packages/api/src/hooks/useRelativeTimeFormatter.ts
*/

import dayjs from "dayjs";
import { useMemo } from "react";

export default function useRelativeTimeFormatter(): (
    dateOrString: Date | string
) => string {
    return useMemo(() => {
        return (dateOrString) => {
            const date = new Date(dateOrString);
            const dateTime = date.getTime();

            if (isNaN(dateTime)) {
                return dateOrString.toString();
            }

            const now = Date.now();
            const deltaInMs = now - dateTime;
            const deltaInMinutes = Math.floor(deltaInMs / 60000);
            const deltaInHours = Math.floor(deltaInMs / 3600000);

            if (deltaInMinutes < 1) {
                return "Just now";
            } else if (deltaInMinutes === 1) {
                return "A minute ago";
            } else if (deltaInHours < 1) {
                return `${deltaInMinutes} minutes ago`;
            } else if (deltaInHours === 1) {
                return "An hour ago";
            } else if (deltaInHours < 5) {
                return `${deltaInHours} hours ago`;
            } else if (deltaInMs <= 24 * 3_600_000) {
                return "Today";
            } else if (deltaInMs <= 48 * 3_600_000) {
                return "Yesterday";
            }

            return dayjs(date).format("hh:mm:ss A");
        };
    }, []);
}
